import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useCallback, useState, useEffect } from 'react';
import ProjectsList from '@rd-web-markets/shared/dist/claim_group/ProjectsList';
import { PROJECT_OVERVIEW_TABLE } from '../constants';
import StartReviewButton from '@rd-web-markets/shared/dist/util/buttons/StartReviewButton';
import changeSetsService from '@rd-web-markets/shared/dist/services/change_sets.service';
import ClientReviewMailerModal from '@rd-web-markets/shared/dist/claim_group/ClientReviewMailerModal';
import { REVIEW_TYPE_CLIENT, REVIEW_TYPE_CONSULTANT } from '@rd-web-markets/shared/dist/util/constants';
import ObjectChangeSetsListWithSnapshots from '@rd-web-markets/shared/dist/technical_review/ObjectChangeSetsListWithSnapshots';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ChangeSetListWithReviewButtonControls from '@rd-web-markets/shared/dist/technical_review/ChangeSetListWithReviewButtonControls';
import { ChangeSet } from '@rd-web-markets/shared/dist/models/ChangeSet';
import IconWihTextOnTheRight from '@rd-web-markets/shared/dist/util/icons/IconWihTextOnTheRight';
import { ChangeSetList } from '@rd-web-markets/shared/dist/models/ChangeSetList';
import { useDispatch } from 'react-redux';
import { setBreadcrumb, clearBreadcrumb } from '@rd-web-markets/shared/dist/store/features/navbarBreadcrumbSlice';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import AssignChangeSetModal from '@components/shared/managerReviews/AssignChangeSetModal';
const TechnicalNarrativesPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'technical_narratives',
  ClaimGroupChildPage: function (_ref) {
    let {
      accountType,
      handleToaster,
      claimGroup,
      setClaimGroup,
      resetClaimGroup,
      t,
      pageIsLoading,
      setPageIsLoading
    } = _ref;
    const [showClientReviewMailerModal, setShowClientReviewMailerModal] = useState(false);
    const [projectForClientReview, setProjectForClientReview] = useState(null);
    const createChangeSet = changeSetsService.useCreateChangeSet(resetClaimGroup, setPageIsLoading);
    const finalizeChangeSet = changeSetsService.useFinalizeChangeSet(resetClaimGroup, setPageIsLoading);
    const approveChangeSet = changeSetsService.useApproveChangeSet(resetClaimGroup, setPageIsLoading);
    const rejectChangeSet = changeSetsService.useRejectChangeSet(resetClaimGroup, setPageIsLoading);
    const createChangeSetForClient = changeSetsService.useCreateChangeSetForClient(resetClaimGroup, setPageIsLoading, handleToaster);
    const dispatch = useDispatch();
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [projectForAssignment, setProjectForAssignment] = useState(null);
    const [resetProjectForAssignment, setResetProjectForAssignment] = useState(null);
    useEffect(() => {
      if (claimGroup !== null && claimGroup !== void 0 && claimGroup.company) {
        dispatch(setBreadcrumb({
          label: claimGroup.company.name,
          path: "/".concat(accountType, "/companies/").concat(claimGroup.company.id, "/overview")
        }));
      }
      return () => dispatch(clearBreadcrumb());
    }, [claimGroup, accountType, dispatch]);

    // This is a quick fix for an urgent bug. Its overcomplicated :(
    const [onCreateChangeSetForClient, setOnCreateChangeSetForClient] = useState(null);
    const onCreateChangeSet = useCallback(async resetProject => {
      return async function () {
        await createChangeSet(...arguments);
        await resetProject();
      };
    }, [createChangeSet]);
    const onFinalizeChangeSet = useCallback(resetProject => {
      return async function () {
        await finalizeChangeSet(...arguments);
        await resetProject();
      };
    }, [finalizeChangeSet]);
    const onRejectChangeSet = useCallback(resetProject => {
      return async function () {
        await rejectChangeSet(...arguments);
        await resetProject();
      };
    }, [rejectChangeSet]);
    const onApproveChangeSet = useCallback(resetProject => {
      return async function () {
        await approveChangeSet(...arguments);
        await resetProject();
      };
    }, [approveChangeSet]);
    const handleAssignSubmit = async (assignedUserId, sendEmail) => {
      try {
        await createChangeSet(projectForAssignment, 'ClaimProjectReport', REVIEW_TYPE_CONSULTANT, assignedUserId, sendEmail);
        if (resetProjectForAssignment) {
          await resetProjectForAssignment();
        }
      } catch (error) {
        dispatch(handleError(error));
      } finally {
        setShowAssignModal(false);
        setProjectForAssignment(null);
        setResetProjectForAssignment(null);
      }
    };
    const customColumns = ['bussiness_units', 'project_name', project => {
      const reviewType = accountType === 'customer' ? REVIEW_TYPE_CLIENT : null;
      const latestChangeSetModel = new ChangeSetList(project, t).getLatestChangeSet(reviewType);
      const latestSnapshot = latestChangeSetModel === null || latestChangeSetModel === void 0 ? void 0 : latestChangeSetModel.getLatestSnapshot();
      if (!latestSnapshot) {
        return t('no_review_started');
      }
      const snapshotStatus = latestChangeSetModel.getSnapshotStatus(latestSnapshot);
      return /*#__PURE__*/React.createElement(IconWihTextOnTheRight, {
        icon: snapshotStatus.icon,
        text: snapshotStatus.text
      });
    }, accountType !== 'customer' && !claimGroup.active_change_set ? (project, resetProject) => /*#__PURE__*/React.createElement(StartReviewButton, {
      text: t('set_ready_for_manager_review'),
      loading: pageIsLoading,
      claimGroup: claimGroup,
      reviewedObject: project,
      reviewedObjectClass: 'ClaimProjectReport',
      reviewType: REVIEW_TYPE_CONSULTANT,
      onClick: () => {
        setProjectForAssignment(project);
        setResetProjectForAssignment(() => resetProject);
        setShowAssignModal(true);
      }
    }) : null, accountType !== 'customer' && !claimGroup.active_change_set ? (project, resetProject) => /*#__PURE__*/React.createElement(StartReviewButton, {
      text: t('set_ready_for_client_review'),
      loading: pageIsLoading,
      reviewedObject: project,
      claimGroup: claimGroup,
      reviewedObjectClass: 'ClaimProjectReport',
      reviewType: REVIEW_TYPE_CLIENT,
      onClick: () => {
        setProjectForClientReview(project);
        setShowClientReviewMailerModal(true);
        setOnCreateChangeSetForClient(() => {
          return async function () {
            await createChangeSetForClient(...arguments);
            await resetProject();
          };
        });
      }
    }) : null, report => !!claimGroup.active_change_set ? t('another_review_was_started_please_complete_it_first') : /*#__PURE__*/React.createElement(Link, {
      as: Button,
      to: "/".concat(accountType, "/claim_groups/").concat(claimGroup.id, "/technical_narratives/").concat(report.id)
    }, t('view_technical_narrative_details')), 'toggle_expand'].filter(Boolean);
    const customHeaders = [PROJECT_OVERVIEW_TABLE.headers.find(h => h.text === 'business_unit'), PROJECT_OVERVIEW_TABLE.headers.find(h => h.text === 'name'), {
      text: t('review_state')
    }, accountType !== 'customer' ? {
      text: ''
    } : null, accountType !== 'customer' ? {
      text: ''
    } : null, {
      text: ''
    }, {
      text: ''
    }].filter(Boolean);
    const projectsAdditionalQueryParams = accountType === 'customer' ? {
      under_review: true
    } : {};
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProjectsList, {
      isTechnicalNarrativePage: true,
      customHeaders: customHeaders,
      customColumns: customColumns,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup,
      groupProjects: false,
      additionalQueryParams: projectsAdditionalQueryParams,
      renderExpandedRowContent: row => {
        var _project$active_chang;
        const {
          project,
          resetProject
        } = row.data;
        return /*#__PURE__*/React.createElement(ChangeSetListWithReviewButtonControls, {
          canShowStartTrackingChangesButton: false,
          reviewedObject: project,
          reviewedObjectClass: 'ClaimProjectReport',
          snapshotsContainingObject: project,
          reviewType: (_project$active_chang = project.active_change_set) === null || _project$active_chang === void 0 ? void 0 : _project$active_chang.review_type,
          snapshotsResetDataFn: resetProject,
          showSnapshotsForAllReviewTypes: true,
          isLoading: pageIsLoading,
          claimGroup: claimGroup
          // createChangeSet={createChangeSet}
          ,
          finalizeChangeSet: onFinalizeChangeSet(resetProject),
          approveChangeSet: onApproveChangeSet(resetProject),
          rejectChangeSet: onRejectChangeSet(resetProject)
        });
      },
      onToggleExpandProjectRow: project => {
        project.expanded = !project.expanded;
      }
    }), showClientReviewMailerModal && projectForClientReview && /*#__PURE__*/React.createElement(ClientReviewMailerModal, {
      setClaimGroup: setClaimGroup,
      claimGroup: claimGroup,
      show: showClientReviewMailerModal,
      setModalShow: setShowClientReviewMailerModal,
      loading: pageIsLoading,
      createChangeSetForClient: onCreateChangeSetForClient,
      reviewType: REVIEW_TYPE_CLIENT,
      reviewedObjectClass: 'ClaimProjectReport',
      reviewedObject: projectForClientReview
    }), /*#__PURE__*/React.createElement(AssignChangeSetModal, {
      show: showAssignModal,
      onHide: () => {
        setShowAssignModal(false);
        setProjectForAssignment(null);
        setResetProjectForAssignment(null);
      },
      claimGroup: claimGroup,
      title: t('assign_to_user'),
      onSubmit: handleAssignSubmit
    }));
  }
});
export default TechnicalNarrativesPage;